
export enum ServiceLevelCd {
	BRONZE = 'Bronze',
	CUST_DIGEST = 'CustDigest',
	GOLD = 'Gold',
	SILVER = 'Silver',
	WHITE_GLOVE = 'WhiteGlove'}

